import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconTrash } from '@/assets/svgs/trash-outline-medium.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index'
import rem from '@/utils/rem'
import { useContext } from 'react'
import api from "@/services/api/packageFolder.js";

export default function DeleteFolderModal({ visible, close, id }) {

	const { addToastMessage } = useContext(ToastContext);

	const handleDeleteFolderSubmit = async () => {
		const [error] = await api.deleteFolder(id);

		if (error) {
			close()
			return addToastMessage('Failed to delete folder', 'error')
		}

		document.getElementById('reload-eclips')?.click();
		close()
		addToastMessage('You have deleted the folder.', 'success')
	}

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package-error'}>
										<IconTrash />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<span> Delete Folder</span>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div style={{ fontSize: rem(14), textAlign: 'center' }}>
							Are you sure you want to delete the selected folder ?
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button error text="Delete" submit={handleDeleteFolderSubmit} />
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
